export const LOADING_SIZE = 4;
export const RECOMMENDATIONS_CONTEXT = 'recommendations';
